import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Button,
  Chip,
  Stack,
  Divider,
  Dialog,
  DialogContent,
  IconButton,
  Paper,
  useTheme,
  useMediaQuery,
  Fade,
} from '@mui/material';
import { motion } from 'framer-motion';
import EventIcon from '@mui/icons-material/Event';
import ArticleIcon from '@mui/icons-material/Article';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkIcon from '@mui/icons-material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

// Blog posts section removed as requested

const events = [
  {
    id: 1,
    title: 'CAITME 2024, Uzbekistan',
    description: 'WTT International invites you to visit us at CAITME 2024, Uzbekistan in Stall No. E130, Pavilion - 4.',
    image: '/images/Events/1726038349004.jpg',
    date: '8 months ago',
    location: 'Uzbekistan, Stall No. E130, Pavilion - 4',
    type: 'Exhibition',
    registrationLink: 'https://caitme.uz/en',
    videoLink: 'https://www.youtube.com/watch?v=cHM8lz00_1Y'
  },
  {
    id: 2,
    title: 'Celebrating World Environment Day 2024 with Visionary Workshop',
    description: 'We are thrilled to share that, our Managing Director Mr. D. Venkatesh, took center stage as the resource person for the Sectorial Stakeholder Workshop organized by the Rajasthan State Pollution Control Board.',
    image: '/images/Events/2nd.jpg',
    date: '11 months ago',
    location: 'Rajasthan State Pollution Control Board',
    type: 'Workshop',
    registrationLink: 'https://www.environment.rajasthan.gov.in/',
    videoLink: 'https://www.youtube.com/watch?v=DUOurB2lQYU',
    fullDescription: 'Detailed description of the workshop...'
  },
  {
    id: 3,
    title: 'UPGRADE YOURSELF - WTT INTERNATIONAL TRAINING PROGRAM',
    description: 'Enhance your skills with our comprehensive training program designed for professionals in the water treatment industry.',
    image: '/images/Events/WTT-D-Venkatesh.jpg',
    date: '1 year ago',
    location: 'WTT International Headquarters',
    type: 'Training',
    registrationLink: 'https://wttint.com/training',
    videoLink: 'https://www.youtube.com/watch?v=cHM8lz00_1Y'
  },
  {
    id: 4,
    title: 'WTT International - INDIA@ITMA Milan 2023',
    description: 'Proud to represent India at ITMA Milan 2023, the world\'s largest international textile and garment technology exhibition.',
    image: '/images/Events/itme2022.jpg',
    date: '1.5 years ago',
    location: 'Milan, Italy',
    type: 'Exhibition',
    registrationLink: 'https://itma.com/',
    videoLink: 'https://www.youtube.com/watch?v=DUOurB2lQYU'
  },
  {
    id: 5,
    title: 'WTT Only Supplier Of Single Skid RO With 97% Water Recovery',
    description: 'WTT International has become the only supplier of single skid RO with 97% water recovery, a significant achievement in water treatment technology.',
    image: '/images/Events/WTT-D-Venkatesh.jpg',
    date: 'January 2024',
    location: 'India',
    type: 'Press Release',
    registrationLink: 'https://textileinsights.in/wtt-only-supplier-of-single-skid-ro-with-97-water-recovery/'
  },
  {
    id: 6,
    title: 'Empowering Tiruppur: WTT\'s Sustainable Solutions for the Textile Industry',
    description: 'WTT International provides sustainable water treatment solutions for the textile industry in Tiruppur, helping to address environmental challenges while supporting industry growth.',
    image: '/images/Events/Venkatesh-WTT-International-1a.jpg',
    date: 'February 28, 2024',
    location: 'Tiruppur, India',
    type: 'Press Release',
    registrationLink: 'https://www.indiantextilemagazine.in/empowering-tiruppur-wtts-sustainable-solutions-for-the-textile-industry/'
  },
  {
    id: 7,
    title: 'INDIA ITME 2022 - A Huge Success',
    description: 'We would like to express our heartfelt gratitude to all the organizers, participants, and visitors, who made our exhibit in INDIA ITME 2022 a huge success! The CaRe system (A Novel Innovation for Caustic Recovery) was the show stealer.',
    image: '/images/Events/itme2022.jpg',
    date: 'December 2022',
    location: 'India',
    type: 'Exhibition',
    registrationLink: 'https://itme.com/',
    videoLink: 'https://www.youtube.com/watch?v=ITJlQX1ZQQk'
  },
  {
    id: 8,
    title: 'WTT International Exhibition Booth by Event Squad 360',
    description: 'Our stunning exhibition booth designed by Event Squad 360 showcased our latest innovations in water treatment technology.',
    image: '/images/Events/oviov.jpg',
    date: '2 years ago',
    location: 'International Exhibition Center',
    type: 'Exhibition',
    registrationLink: 'https://eventsquad360.com/',
    videoLink: 'https://www.youtube.com/watch?v=ITJlQX1ZQQk'
  },
  {
    id: 9,
    title: 'Technical Seminar on Emerging Trends in Effluent Treatment Technology',
    description: 'Join us for an insightful seminar on the latest advancements in effluent treatment technology led by industry experts.',
    image: '/images/Events/Venkatesh-WTT-International-1a.jpg',
    date: '2.5 years ago',
    location: 'Virtual Event',
    type: 'Seminar',
    registrationLink: 'https://wttint.com/seminars',
    videoLink: 'https://www.youtube.com/watch?v=cHM8lz00_1Y'
  },
  {
    id: 10,
    title: '77th Independence Day Celebration',
    description: 'The 77th Independence Day was celebrated by WTT International Private Limited. We had a wonderful opportunity to learn about Indian history, including the sacrifices required to attain independence, during our Administrative Director Madam speech.',
    image: '/images/Events/ind.jpg',
    date: 'August 15, 2023',
    location: 'WTT International Office',
    type: 'Company Event',
    registrationLink: 'https://www.linkedin.com/posts/wttinternational_proudtobeindian-activity-7097809965645533185-64s_/'
  }
];

// Styled components for enhanced design
const VideoCard = ({ videoUrl, thumbnail, title, onClick }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        borderRadius: 3,
        overflow: 'hidden',
        cursor: 'pointer',
        '&:hover .play-button': {
          transform: 'scale(1.2)',
        },
        '&:hover .overlay': {
          opacity: 0.8,
        },
        '&:hover img': {
          transform: 'scale(1.05)',
        },
        boxShadow: '0 15px 50px rgba(0,0,0,0.2)',
        height: 280,
      }}
      onClick={onClick}
    >
      <Box
        component="img"
        src={thumbnail}
        alt={title}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transition: 'transform 0.5s ease',
        }}
      />
      <Box
        className="overlay"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.3) 100%)',
          opacity: 0.6,
          transition: 'opacity 0.3s ease',
        }}
      />
      <Box
        className="play-button"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 70,
          height: 70,
          borderRadius: '50%',
          background: 'rgba(255, 0, 0, 0.9)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'transform 0.3s ease',
          boxShadow: '0 6px 20px rgba(0,0,0,0.4)',
        }}
      >
        <PlayArrowIcon sx={{ color: 'white', fontSize: 35 }} />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          p: 3,
          background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.6) 60%, rgba(0,0,0,0) 100%)',
        }}
      >
        <Typography 
          variant="h6" 
          color="white" 
          fontWeight="bold"
          sx={{
            textShadow: '0 2px 4px rgba(0,0,0,0.5)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

const BlogEvents = () => {
  const [openVideo, setOpenVideo] = useState(false);
  const [currentVideo, setCurrentVideo] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const handleOpenVideo = (videoUrl) => {
    setCurrentVideo(videoUrl);
    setOpenVideo(true);
  };
  
  const handleCloseVideo = () => {
    setOpenVideo(false);
  };
  
  // Extract YouTube video ID from URL
  const getYoutubeId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };
  return (
    <Box sx={{ bgcolor: '#f8f9fa', minHeight: '100vh' }}>
      {/* Hero Section */}
      <Box
        sx={{
          position: 'relative',
          height: '390px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url("/images/blog.JPG")',
          backgroundSize: 'cover',
          backgroundPosition: 'center 40%',
          color: 'white',
          textAlign: 'center',
          mb: 0,
        }}
      >
        <Container 
          maxWidth="lg"
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            pl: { xs: 0, md: 0 }
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            style={{ marginLeft: '-1rem' }}
          >
            <Box
              sx={{
                maxWidth: '600px',
                textAlign: 'left',
                position: 'relative',
                p: 4,
                ml: { xs: 2, md: 4 },
                background: 'linear-gradient(135deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 100%)',
                backdropFilter: 'blur(8px)',
                borderRadius: '10px',
                border: '1px solid rgba(255,255,255,0.1)',
                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '4px',
                  height: '100%',
                  background: 'linear-gradient(to bottom, #0288d1, transparent)',
                  borderRadius: '4px 0 0 4px',
                }
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2rem', md: '2.5rem' },
                  fontWeight: 700,
                  mb: 2,
                  textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                  position: 'relative',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: -8,
                    left: 0,
                    width: '60px',
                    height: '3px',
                    background: 'linear-gradient(90deg, #0288d1, rgba(2,136,209,0.2))',
                    borderRadius: '2px',
                  }
                }}
              >
                Blog & Events
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  maxWidth: '500px',
                  opacity: 0.9,
                  textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                  fontSize: { xs: '0.9rem', md: '1.1rem' },
                  lineHeight: 1.6,
                  pl: 0.5
                }}
              >
                Stay updated with our latest news, events, and insights
              </Typography>
            </Box>
          </motion.div>
        </Container>
      </Box>

      {/* Content Section */}
      <Container maxWidth="xl" sx={{ py: { xs: 4, md: 8 } }}>
        {/* Section Title */}
        <Box sx={{ mb: 6, textAlign: 'center' }}>
          <Typography 
            variant="h4" 
            component="h2" 
            fontWeight="bold" 
            gutterBottom
            sx={{
              background: 'linear-gradient(45deg, #0099cc 30%, #00c6cf 90%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '0.5px',
              fontSize: { xs: '2rem', md: '2.5rem' }
            }}
          >
            Events & Updates
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 800, mx: 'auto', fontSize: '1.1rem' }}>
            Stay informed with our latest events, achievements, and company activities
          </Typography>
          <Divider sx={{ width: '10%', mx: 'auto', borderWidth: 2, borderColor: 'primary.main', mt: 3 }} />
        </Box>
        
        {/* Featured Videos Section */}
        <Box sx={{ mb: 8 }}>
          <Typography 
            variant="h5" 
            component="h3" 
            fontWeight="bold" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              mb: 4,
              '&::after': {
                content: '""',
                flexGrow: 1,
                height: '2px',
                background: 'linear-gradient(to right, rgba(255, 0, 0, 0.7), rgba(255, 0, 0, 0))',
                ml: 2
              }
            }}
          >
            <YouTubeIcon sx={{ mr: 1, color: '#ff0000', fontSize: 28 }} />
            Featured Videos
          </Typography>
          
          <Box sx={{ 
            p: 2, 
            borderRadius: 4, 
            mb: 2,
            background: 'linear-gradient(145deg, rgba(249,249,249,0.8) 0%, rgba(240,240,240,0.4) 100%)',
            backdropFilter: 'blur(10px)',
            boxShadow: 'inset 0 1px 1px rgba(255,255,255,0.8), 0 10px 40px rgba(0,0,0,0.1)'
          }}>
            <Grid container spacing={3}>
              {events
                .filter(event => event.videoLink)
                .slice(0, 3)
                .map((event, index) => (
                  <Grid item xs={12} md={4} key={`video-${event.id}`}>
                    <VideoCard 
                      videoUrl={event.videoLink}
                      thumbnail={event.image}
                      title={event.title}
                      onClick={() => handleOpenVideo(event.videoLink)}
                    />
                  </Grid>
                ))}
            </Grid>
          </Box>
        </Box>

        {/* Combined Content */}
        <Box sx={{ mb: 4 }}>
          <Typography 
            variant="h5" 
            component="h3" 
            fontWeight="bold" 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              mb: 4,
              '&::after': {
                content: '""',
                flexGrow: 1,
                height: '2px',
                background: 'linear-gradient(to right, rgba(0, 156, 204, 0.7), rgba(0, 198, 207, 0))',
                ml: 2
              }
            }}
          >
            <EventIcon sx={{ mr: 1, color: '#0099cc', fontSize: 28 }} />
            Events & Activities
          </Typography>
        </Box>
        
        <Grid container spacing={4}>
          {events.map((event, index) => (
            <Grid item xs={12} md={4} key={event.id}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
              >
                <Card
                  sx={{
                    height: 550, // Fixed height for all cards
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 50px rgba(0,0,0,0.15)',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    backdropFilter: 'blur(10px)',
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: '0 20px 80px rgba(0,0,0,0.2)'
                    },
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '5px',
                      background: 'linear-gradient(90deg, #0099cc, #00c6cf)',
                      zIndex: 1
                    }
                  }}
                >
                  <CardMedia
                    component="img"
                    height="220"
                    image={event.image}
                    alt={event.title}
                    sx={{ 
                      objectFit: 'cover',
                      transition: 'transform 0.5s ease',
                      '&:hover': {
                        transform: 'scale(1.05)'
                      }
                    }}
                  />
                  <CardContent sx={{ p: 3, flexGrow: 1, overflow: 'auto', height: 200, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <Chip 
                      label={event.type}
                      size="small"
                      sx={{
                        bgcolor: 
                          event.type === 'Exhibition' ? '#3f51b5' :
                          event.type === 'Workshop' ? '#00796b' :
                          event.type === 'Press Release' ? '#d32f2f' :
                          event.type === 'Training' ? '#ff9800' :
                          event.type === 'Seminar' ? '#7b1fa2' :
                          event.type === 'Company Event' ? '#0288d1' :
                          'primary.main',
                        color: 'white',
                        mb: 2,
                        fontWeight: 'bold',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                      }}
                    />
                    <Typography
                      variant="h6"
                      component="h3"
                      gutterBottom
                      sx={{ 
                        fontWeight: 'bold',
                        fontSize: '1.1rem',
                        lineHeight: 1.3,
                        mb: 2,
                        color: '#1a1a2e',
                        height: 'auto',
                        maxHeight: '4.2rem',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical'
                      }}>
                      {event.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ 
                        mb: 3,
                        lineHeight: 1.6,
                        fontSize: '0.9rem',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: 'vertical',
                        height: 'auto',
                        maxHeight: '4.8rem',
                        width: '100%'
                      }}
                    >
                      {event.description}
                    </Typography>
                    <Box sx={{ width: '100%', mt: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <AccessTimeIcon fontSize="small" sx={{ color: '#0099cc', opacity: 0.9, minWidth: 24, mr: 1 }} />
                        <Typography variant="body2" color="text.secondary" fontWeight="medium">
                          {event.date}
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                        <LocationOnIcon fontSize="small" sx={{ color: '#0099cc', opacity: 0.9, minWidth: 24, mr: 1, mt: 0.3 }} />
                        <Typography 
                          variant="body2" 
                          color="text.secondary"
                          fontWeight="medium"
                          sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            width: '100%'
                          }}
                        >
                          {event.location}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                  <CardActions sx={{ p: 3, pt: 2, flexDirection: 'column', gap: 1, borderTop: '1px solid rgba(0,0,0,0.08)' }}>
                    {event.videoLink && (
                      <Button 
                        variant="outlined"
                        fullWidth
                        startIcon={<YouTubeIcon sx={{ color: '#ff0000' }} />}
                        sx={{ 
                          textTransform: 'none',
                          fontWeight: 600,
                          mb: 1,
                          borderRadius: '8px',
                          borderColor: '#ff0000',
                          color: '#ff0000',
                          '&:hover': {
                            borderColor: '#ff0000',
                            backgroundColor: 'rgba(255,0,0,0.04)'
                          }
                        }}
                        href={event.videoLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Watch Video
                      </Button>
                    )}
                    <Button 
                      variant="contained"
                      fullWidth
                      startIcon={event.type === 'Press Release' ? <OpenInNewIcon /> : <LinkIcon />}
                      sx={{ 
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: '8px',
                        background: 'linear-gradient(45deg, #0099cc 30%, #00c6cf 90%)',
                        boxShadow: '0 4px 20px rgba(0,156,204,0.4)',
                        '&:hover': {
                          boxShadow: '0 6px 25px rgba(0,156,204,0.6)'
                        }
                      }}
                      href={event.registrationLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {event.type === 'Press Release' ? 'Read Article' : 
                       event.type === 'Exhibition' ? 'Learn More' : 
                       event.type === 'Company Event' ? 'View Details' : 
                       'Register Now'}
                    </Button>
                  </CardActions>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
        
        {/* Video Dialog */}
        <Dialog
          open={openVideo}
          onClose={handleCloseVideo}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: '0 10px 50px rgba(0,0,0,0.3)',
              bgcolor: '#000',
            }
          }}
        >
          <DialogContent sx={{ p: 0, position: 'relative', height: isMobile ? '300px' : '550px' }}>
            <IconButton
              onClick={handleCloseVideo}
              sx={{
                position: 'absolute',
                top: 10,
                right: 10,
                bgcolor: 'rgba(0,0,0,0.5)',
                color: 'white',
                zIndex: 10,
                '&:hover': {
                  bgcolor: 'rgba(0,0,0,0.7)',
                }
              }}
            >
              <CloseIcon />
            </IconButton>
            <Box
              component="iframe"
              src={`https://www.youtube.com/embed/${getYoutubeId(currentVideo)}?autoplay=1&rel=0&modestbranding=1`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              sx={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
            />
          </DialogContent>
        </Dialog>
      </Container>
    </Box>
  );
};

export default BlogEvents;